import { auth } from "@/main";
import { connectWebSocket } from "./websocket";

export default function getPedidos(database) {
  const getPedidosInternal = async () => {
    if (auth.currentUser == null) {
      console.log("Usuário não autenticado. Não é possível obter pedidos.");
      return "Unauthorized";
    }
    try {
      const log = await auth.currentUser.getIdToken(true);
      const message = {
        action: "subscribe",
        empresa: database,
        authToken: log,
      };
      let socket = await connectWebSocket();
      socket.send(JSON.stringify(message));
      console.log("Mensagem de assinatura enviada com sucesso!");
    } catch (e) {
      console.error("Erro ao tentar conectar ou enviar mensagem:", e);
      const delay = 10000;
      console.log(`Tentando novamente em ${delay / 1000} segundos...`);
      setTimeout(getPedidosInternal, delay);
    }
  };
  getPedidosInternal();
}